export class WorkflowEFTEditorResultDto {
    allowEFTEdit: boolean;
}
